import { createSlice ,current} from '@reduxjs/toolkit';
import { set } from "lodash"
export const loaderSlice = createSlice({
  name: 'loader',
  initialState:{
    reconLoader: {
        fileUploadLoader: false,
        formGlobalLoader:false,
        statusDetailLoader: {
          statusDetailListLoader: false,
          ediLoader: false
        }
    }
  },
  reducers: {
    setLoader: (state, {payload: {path, value}}) => {
        set(state, `reconLoader.${path}`, value)
    } 
  }
});

export const { setLoader } = loaderSlice.actions;

export default loaderSlice.reducer;
